/*
無人チェックイン API取得処理
*/
import gql from 'graphql-tag';

// APIのデータ
export const GET_API = gql`
    query ($url: String, $key: String, $data: String ) {
        GetMypageVisitApi(
            url: $url
            key: $key
            data: $data
        )
        {
            data
        }
    },
`;
